import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/(landing)/page.jsx");
